<template>
    <v-card class="grey lighten-3" data-testid="client-filters">
        <v-card-text>
            <v-flex v-for="(item, key, i) in localFilterQuestions" :key="key">
                <v-layout row wrap>
                    <v-flex xs12 class="text-md-h6 text-sm-body-1 body-2 mb-2">
                        <span :tabindex="i" :id="`questionTitle${i}`">
                            <span class="question-number mr-2">
                                {{ '* ' + (i + 1) + '. ' }}
                            </span>
                            <span class="question ql-editor" v-html="item['question' + upperLocale] || ''" />
                        </span>
                    </v-flex>
                    <v-flex
                        v-for="j in 2"
                        xs6
                        sm4
                        md2
                        mb-2
                        :key="j"
                    >
                        <v-btn
                            :tabindex="i"
                            :color="localAnswers[i] === j ? 'button-cs-secondary-color' : ''"
                            text-color="white"
                            class="time-chip"
                            rounded
                            large
                            @click="onAnswerClick(i, j)"
                        >
                            <v-icon
                                v-if="localAnswers[key] === j"
                                class="mr-2"
                                small>
                                check_circle
                            </v-icon>
                            <span>{{ $t(j === 1 ? 'base.yes' : 'base.no') }}</span>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-layout class="row">
                <v-flex xs12 class="text-center">
                    <previous-button
                        @previousStep="() => { $emit('previousStep') }"
                    />
                    <next-button
                        :disabled="loading || !areAnswersValid()"
                        :loading="loading"
                        id="clientFiltersContinue"
                        @nextStep="nextStep"
                    />
                </v-flex>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, mapValues, replace, size } from 'lodash';
import { setFocusForAccessibility } from '@/utils';
import PreviousButton from '@/components/buttons/PreviousButton';
import NextButton from '@/components/buttons/NextButton.vue';

export default {
    name: 'step-client-filters',
    components: {
        PreviousButton,
        NextButton
    },
    props: {
        answers: { type: Object, required: true },
        selectedService: { type: Object, required: true },
        loading: { type: Boolean, required: true },
        filterQuestions: { type: Object, required: true },
    },
    data() {
        return {
            localAnswers: {
                0: null,
                1: null,
                2: null,
            },
            localFilterQuestions: {},
        };
    },
    created() {
        // remove LSEP symbol
        this.localFilterQuestions = cloneDeep(this.filterQuestions);
        this.localFilterQuestions = mapValues(this.localFilterQuestions, (e) => {
            e.questionFr = replace(e.questionFr, /\u2028/g, '');
            e.questionEn = replace(e.questionEn, /\u2028/g, '');
            return e;
        });
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
    },
    watch: {
        answers(value) {
            this.localAnswers = value && size(value) ? { ...value } : this.localAnswers;
        },
    },
    filters: {
        escapeHtml(value) {
            return (value || '').replace(/</g, '&lt;');
        },
        nl2br(value) {
            return (value || '').replace(/\r\n|\r|\n/g, '<br />');
        },
    },
    methods: {
        /**
         * Returns whether the answers are valid
         * (to disable continue button)
         */
        areAnswersValid() {
            for (let i = 0; i < size(this.filterQuestions); i++) {
                if (this.localAnswers[i] === null) {
                    return false;
                }
            }
            return true;
        },

        /**
         * Emits next step event for parent component
         */
        nextStep() {
            this.$emit('answers', this.localAnswers);
            this.$emit('nextStep');
        },

        /**
         * When an answer is clicked
         */
        onAnswerClick(index, value) {
            this.localAnswers = {
                ...this.localAnswers,
                [index]: value,
            };

            // accessibility
            const nextQuestionIndex = index + 1;
            if (nextQuestionIndex < size(this.localFilterQuestions)) {
                setFocusForAccessibility(`questionTitle${nextQuestionIndex}`, 0);
            }
            else {
                setFocusForAccessibility('clientFiltersContinue', 0);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';

.question-number,
.question {
    float: left;
}

.ql-editor {
    all: revert;
}

.question {
    width: 94%;
}

.question::v-deep ul {
    list-style: initial!important;
}

.question::v-deep em {
    font-style: italic!important;
}

// 600px et -
@media only screen and (max-width: 599px) {
    .question {
        width: 80%;
    }
}
</style>
